import "./customadsList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import CustomAdsTable from "../adscustomtable/CustomAdsTable";

const CustomAdsList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <CustomAdsTable />
      </div>
    </div>
  );
};

export default CustomAdsList;
